// Add this to src/api/geneCodes/GxEApi.ts

import { ENV } from '../../config/runtimeEnv';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_LABIQ_SERVER || '';

// Helper for common API headers

export interface GxESnp {
	snp_name: string;
	evidence_level: string;
	pmid_count: number;
	finding: string;
	effect_size?: string;
	therapeutic_window?: string;
}

export interface GxEGene {
	gene_name: string;
	evidence_level: string;
	pmid_count: number;
	finding: string;
	molecular_details?: string;
	clinical_implications?: string;
	therapeutic_window?: string;
	confidence_score: number;
	pmid_years?: string;
	pmids: string[];
	snps: GxESnp[];
}

export interface GxEIntervention {
	intervention_id: string;
	intervention_code: string;
	intervention_name: string;
	description: string;
	gene_count: number;
	snp_count: number;
	total_studies: number;
	overall_evidence: 'strong' | 'moderate' | 'weak' | 'mixed';
	category: 'diet' | 'supplements' | 'activity' | 'lifestyle' | 'other';
	genes: GxEGene[];
}

export interface GxEResponse {
	success: boolean;
	category: string;
	interventions: GxEIntervention[];
	error?: string;
}

/**
 * Fetch Gene × Environment interaction data for a specific category and sample
 */
export const fetchGxEData = async (
	category: string,
	sampleId: string,
	threshold: 'low' | 'moderate' | 'high' = 'low',
	genes?: string[]
): Promise<GxEResponse> => {
	const params: any = {
		category,
		sample_id: sampleId,
		threshold
	};

	if (genes && genes.length > 0) {
		params.genes = genes.join(',');
	}

	const response = await http.get(`${API_BASE_URL}/gxe-data`, {
		params
	});

	return response.data;
};